import {

  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAIL,

  MARK_NOTIFICATIONS_REQUEST,
  MARK_NOTIFICATIONS_SUCCESS,
  MARK_NOTIFICATIONS_FAIL,

  MARK_ALL_AS_READ_REQUEST,
  MARK_ALL_AS_READ_SUCCESS,
  MARK_ALL_AS_READ_FAIL,


  
  DELETE_ALL_NOTIFCATIONS_REQUEST,
  DELETE_ALL_NOTIFCATIONS_SUCCESS,
  DELETE_ALL_NOTIFCATIONS_FAIL,


} from "../constants/notificationsConstants";
import api from "../../api";



export const getnotifcationsAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_NOTIFICATIONS_REQUEST });



    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/v1/get-notifcations?${queryString}` : `/api/v1/get-notifcations`;

    console.log(queryParams)
    const { data } = await api.get(url);



    dispatch({
      type: GET_NOTIFICATIONS_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch({
      type: GET_NOTIFICATIONS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
export const marNotificationsAction = (notification_id) => async (dispatch) => {
  try {
    dispatch({ type: MARK_NOTIFICATIONS_REQUEST });

    const { data } = await api.put("/api/v1/mark-notifcations", notification_id,
      { headers: { "Content-Type": "application/json" } }
    );

    dispatch({
      type: MARK_NOTIFICATIONS_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch({
      type: MARK_NOTIFICATIONS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
export const markAllAsReadAction = (notification_id) => async (dispatch) => {
  try {
    dispatch({ type: MARK_ALL_AS_READ_REQUEST });

    const { data } = await api.put("/api/v1/mark-all-as-read")

    dispatch({
      type: MARK_ALL_AS_READ_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch({
      type: MARK_ALL_AS_READ_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
export const deleteAllNotifcationsAction = (notification_id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ALL_NOTIFCATIONS_REQUEST });

    const { data } = await api.delete("/api/v1/delete-all-notifcations")

    dispatch({
      type: DELETE_ALL_NOTIFCATIONS_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch({
      type: DELETE_ALL_NOTIFCATIONS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
